import axios from 'axios';
import { normalizeEnumOption } from './enumOption';

// 订单录入，我的车辆
export const doQueryVehicleAll = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doQueryVehicleAll',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆/外调车-新增/修改/邀请
export const vehicleDoSave = async (data) => new Promise((resolve, reject) => {
  let url = '';
  if (data.submitType === 'add') {
    // 新增状态
    if (data.applyRemark) {
      // 如果有【邀请说明】，说明要调用邀请接口，之所以用这个判断，是因为这个是邀请的必填项
      url = '/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecordForOwnCar';
    } else {
      // 其他情况，调用新增接口
      url = '/vehicleDataInfoBO.ajax?cmd=doSaveVehicleInfo';
    }
  } else {
    // 修改状态
    if (data.applyRemark) {
      // 修改的时候，外调车转自有车
      url = '/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecordForOwnCar';
    } else {
      url = '/vehicleDataInfoBO.ajax?cmd=doUpdateVehicleInfo';
    }
  }
  delete data.isSwitchToInvite;
  console.log('提交参数', data);
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-保存新增（自有车档案-新增保存）
export const myCarEdit = async (data) => new Promise((resolve, reject) => {
  let url = '';
  if (data.isSwitchToInvite) {
    // 邀请模式
    url = '/vehicle/vehicleAdd/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecordForOwnCar';
  } else {
    // 新增/修改模式
    url = data.vehicleCode ? '/vehicleDataInfoBO.ajax?cmd=doUpdateVehicleInfo' : '/vehicleDataInfoBO.ajax?cmd=doSaveVehicleInfo';
  }
  console.log('提交参数', data);
  axios({
    url,
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-保存新增（邀请）
export const doSaveApplyRecordForOwnCar = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicle/vehicleAdd/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecordForOwnCar',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-详情（自有车档案-获取订单信息）
export const getAllVehicleInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=getAllVehicleInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-获取审核数据（自有车档案-查询审核数据）
export const getAllVehicleInfoVerAudit = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=getAllVehicleInfoVerAudit',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆档案-历史档案（点击车牌看详情）
export const getAllVehicleInfoVer = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=getAllVehicleInfoVer',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表（车辆档案-自有车档案-查询列表）
export const myCarSearchList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doQueryVehicleList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-启用/闲置（自有车档案-启用/闲置）
export const updateVehicleState = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=updateVehicleState',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-删除（自有车档案-删除）
export const doRemoveVehicle = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doRemoveVehicle',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-点击车牌查看车辆详情-维护记录-证照记录/投保记录
export const queryVehicleCertificatesInsurance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=queryVehicleCertificatesInsurance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-点击车牌查看车辆详情-运营记录-常跑路线
export const queryVehicleOftenRunOrderInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=queryVehicleOftenRunOrderInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-点击车牌查看车辆详情-运营记录-维修记录
export const getUserRepairList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=getUserRepairList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-点击合作车队数量
export const doQueryTenantByVehicleCode = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doQueryTenantByVehicleCode',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-车辆列表-点击合作车队数量-解除合作
export const dissolveCooperationVehicle = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=dissolveCooperationVehicle',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-新增车辆-车辆归属-线路绑定（自有车档案-模糊查询线路信息）
export const getCustomerLineByLineCode = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/cmCustomerLineBO.ajax?cmd=getCustomerLineByLineCode',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-新增车辆-司机信息（自有车档案-新增车辆-查询司机列表）
export const doQueryCarDriver = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doQueryCarDriver',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-新增车辆-查询车辆注册信息（自有车档案-查询车辆注册信息，输入车牌号码后调用）-- 这个文档没加
export const getVehicleIsRegister = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicle/vehicleAdd/vehicleDataInfoBO.ajax?cmd=getVehicleIsRegister',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
    // if (typeof res === 'string' && res === 'N') {
    //   // 未注册，可以正常保存
    //   resolve({
    //     unregistered: '1',
    //     data: null,
    //   });
    // } else if (typeof res === 'object') {
    //   if (res.message) {
    //     // 已注册，不能保存
    //     resolve({
    //       unregistered: '0',
    //       data: null,
    //     });
    //   } else {
    //     // 已注册，有车辆数据，可以邀请，可以正常保存
    //     resolve({
    //       unregistered: '0',
    //       data: res,
    //     });
    //   }
    // } else {
    //   // 未知状态，抛出返回信息
    //   reject(res);
    // }
    // resolve(typeof res === 'string' && res === 'N');
  }).catch((err) => {
    reject(err);
  });
});

// 我的车辆-新增车辆-识别驾驶证（自有车档案-查询车辆注册信息，上传行驶证照片后调用）-- 这个文档没加
export const getVehicleLicense = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicle/vehicleAdd/ocrBO.ajax?cmd=getVehicleLicense',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-列表
export const queryTrailerManagement = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=queryTrailerManagement',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-新增输入车牌号码检测
export const getTenantTrailerRelByPlateNumber = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=getTenantTrailerRelByPlateNumber',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-新增-挂车车长列表选项
export const getTrailerVehicleLenth = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=getTrailerVehicleLenth',
    method: 'post',
    data,
  }).then(async (res) => {
    const items = Array.isArray(res) ? res : (Array.isArray(res && res.items) ? res.items : []);
    const result = items.map(normalizeEnumOption);
    resolve(result);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-新增/修改
export const doSaveOrUpdate = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=doSaveOrUpdate',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-详情(点击车牌)
export const getTrailerByTrailerId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=getTrailerByTrailerId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-详情-额外信息(点击车牌)
export const getTrailerVerByTrailerId = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=getTrailerVerByTrailerId',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-列表按钮-启用/闲置
export const doUpdUseState = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=doUpdUseState',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-列表按钮-删除
export const deleteTrailer = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=deleteTrailer',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案-列表按钮-更新位置
export const updateLocation = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=updateLocation',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 挂车档案/历史-列表-点击使用情况
export const getTrailerUsedList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/trailerBO.ajax?cmd=getTrailerUsedList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我邀请的--------------------------
// 我邀请的/被我邀请-查询列表
export const doQueryVehicleApplyRecordAll = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doQueryVehicleApplyRecordAll',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我邀请的-详情（再次申请/再次邀请/申请平台仲裁/查看）
export const getVehicleInviteRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=getVehicleInviteRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 被邀请的-详情
export const getVehicleApplyRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=getVehicleApplyRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我邀请的-列表-点击再次申请
export const doSaveApplyRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我邀请的-列表-点击再次邀请
export const doSaveApplyRecordInvite = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecordInvite',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 我邀请的-列表-点击申请平台仲裁
export const doSaveApplyRecordArbitration = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doSaveApplyRecordArbitration',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆预警
// 车辆预警-列表
export const doQueryVehicleWaringList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryVehicleWaringList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理--------------------------
// 车辆管理-历史记录-查询列表
export const doQueryVehicleAllHis = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleDataInfoBO.ajax?cmd=doQueryVehicleAllHis',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理 - 车辆维护 - 车辆年审 - 查询列表
export const annualReviewCarList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryTenantVehicle',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理 - 车辆维护 - 车辆年审 - 新增/修改
export const doSaveVehicleCertificatesInsurance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doSaveVehicleCertificatesInsurance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理 - 车辆维护 - 车辆年审 - 详情
export const getVehicleCertificatesInsurance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=getVehicleCertificatesInsurance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆保险-查询列表
export const doQueryInsuranceList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryInsuranceList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆保险-终止
export const doEndInsurance = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doEndInsurance',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆年审-删除
export const doDelete = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doDelete',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆违章列表
export const doQueryNew = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serv/repair/violationBO.ajax?cmd=doQueryNew',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆违章-新增/修改
export const doSaveViolationRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/violationBO.ajax?cmd=doSaveViolationRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆违章-车辆违章取消
export const doCancel = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/violationBO.ajax?cmd=doCancel',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆违章-车辆违章详情
export const getViolation = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/violationBO.ajax?cmd=getViolation',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆事故-查询列表
export const doQueryAccidentList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryAccidentList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆事故-取消登记/取消定损/取消维修/取消核赔（其实就是取消台账的意思）
export const doDelVehicleAccidentInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doDelVehicleAccidentInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆事故-详情
export const getVehicleAccidentInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=getVehicleAccidentInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆事故新增、修改、定损、核赔、维修接口
export const doSaveVehicleAccidentInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doSaveVehicleAccidentInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆事故-新增-点击车牌号码-点击弹窗确定（车辆事故查询保险信息）
export const getVehicleCertificatesInsuranceForAccident = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=getVehicleCertificatesInsuranceForAccident',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-北斗缴费列表
export const beidouRechargeInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/manualPaymentBO.ajax?cmd=beidouRechargeInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆GPS列表
export const doQueryVehicleStandingBookInfoOut = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doQueryVehicleStandingBookInfoOut',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆GPS列表-新增/修改
export const doSaveOrUpdateVehicleStandingBookInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doSaveOrUpdateVehicleStandingBookInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆GPS列表-详情
export const getVehicleStandingBookInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=getVehicleStandingBookInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆维护-车辆GPS列表-取消按钮（取消台账）
export const cancelVehicleStandingBookInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=cancelVehicleStandingBookInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

export const downloadExcelFile = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicle/vehicleServiceBO.ajax?cmd=downloadExcelFile',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆管理-车辆保险-终止保险-查询员工列表
export const queryStaffInfo = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/serviceProductOilsBO.ajax?cmd=queryStaffInfo',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 北斗缴费-列表-取消缴费
export const cancelBeidouPayment = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/beidouPaymentBO.ajax?cmd=cancelBeidouPayment',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆保养 -- 列表查询
export const getVehicleMaintenanceRecordList = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=getVehicleMaintenanceRecordList',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆保养 -- 新增保养记录
export const doSaveVehicleMaintenanceRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doSaveVehicleMaintenanceRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆保养 -- 查看保养记录详情
export const getVehicleMaintenanceRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=getVehicleMaintenanceRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});

// 车辆保养 -- 保养记录删除
export const doDeleteVehicleMaintenanceRecord = async (data) => new Promise((resolve, reject) => {
  axios({
    url: '/vehicleServiceBO.ajax?cmd=doDeleteVehicleMaintenanceRecord',
    method: 'post',
    data,
  }).then(async (res) => {
    resolve(res);
  }).catch((err) => {
    reject(err);
  });
});
